import { useTranslation } from "react-i18next";

import styles from "../../GameSelector.module.css";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { assignRoom } from "../../../../features/user/userSlice";

function RoomNumberDisplay() {
  const roomId = useAppSelector((state) => state.user.roomId);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  return (
    <div className="RoomNumberDisplay">
      <h2 className={styles.title}>{t("RoomNumberDisplay.title")}</h2>
      <div className={styles.body}>
        {roomId === "" ? (
          <p className={styles.requesting}>
            {t("RoomNumberDisplay.requesting")}
            <span className={styles.dots}>...</span>
          </p>
        ) : (
          <div className={styles.received}>
            <div>{t("RoomNumberDisplay.received")}</div>
            <div className={styles.roomId}>{roomId}</div>
            <button
              className={styles.button}
              onClick={() => {
                dispatch(assignRoom());
              }}
            >
              {t("RoomNumberDisplay.startGameButton")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default RoomNumberDisplay;
